if ($("footer#footer").length) {

    $('#signature').append('<a href="https://www.shopcode.cz/" target="_blank"> | Nakódoval Shopcode</a>');
    $(document).on("click", ".custom-footer > div h4", function () {
        const parent = $(this).closest(".custom-footer > div");
        $(".custom-footer > div").not(parent).removeClass("openIt");
        parent.toggleClass("openIt");
    });

    $('#footer .custom-footer__banner4  .superContact').append($("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail"));
    $('#footer .custom-footer__banner4  .superContact').append($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"));

    $("footer#footer .logoSocial ul.customSocial").append(
        $("footer#footer .contact-box li span.instagram").closest("li"),
    );
    $("footer#footer .logoSocial ul.customSocial").append(
        $("footer#footer .contact-box li span.facebook").closest("li"),
    );

    if ($('.findUs:not(.in-showroom)').length) {
        $(".findUs:not(.in-showroom) .superContact").append(
            $("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel"),
        );
        $(".findUs:not(.in-showroom) .superContact").append(
            $("footer#footer .contact-box li span.mail").closest("li").clone().addClass("mail"),
        );
    }
    if ($('.findUs.in-showroom').length) {
        $(".findUs.in-showroom .superContact .phone").append($("footer#footer .contact-box li span.tel").closest("li").clone().addClass("tel")
        );

    }

}
